<template>
  <Button
    v-bind="$attrs"
    :style="{ height: height + 'px', backgroundColor: color }"
  >
    <slot></slot>
  </Button>
</template>

<script>
export default {
  props: {
    height: {
      type: [String | Number],
      defualt: 32,
    },
    color: String,
  },
};
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/components/r-button.vue